import { Directive,Renderer2, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appNumbersonlywithoutzero]'
})
export class NumbersonlywithoutzeroDirective {

  constructor() { }
  @HostListener('keypress', ['$event']) keyEvent(event) {
 
   
    // console.log(event)
    // const initalValue = this.elRef.nativeElement.value;

    // this.elRef.nativeElement.value = initalValue.replace(/[^0-9]*/g, '');
   
    // if ( initalValue !== this.elRef.nativeElement.value) {
    //   event.stopPropagation();
    // }
    debugger;
    let val=event.target.value;
    if(val===''){
      const charCode = (event.which) ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 49 || charCode > 57) || charCode==13) {
        return false;
      }
      return true;
    }
    else{
      const charCode = (event.which) ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) || charCode==13) {
        return false;
      }
      return true;
    }
  }
}
